export const keys = [
  ["ё", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  ["й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х", "ъ"],
  ["ф", "ы", "в", "а", "п", "р", "о", "л", "д", "ж", "э"],
  ["я", "ч", "с", "м", "и", "т", "ь", "б", "ю"]
] as const;

export type Key = " " | "backspace" | (typeof keys)[number][number];
